export const ACCESS_TOKEN = "accessToken";
export const ANONYMOUS_BOOKING_TOKEN = "anonymousBookingToken";

export const removeMagicTokenFromSearchParams = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const currentUrl = new URL(window.location.href);
  urlParams.delete("magicToken");
  currentUrl.search = urlParams.toString();

  window.history.replaceState({}, "", currentUrl.toString());
};

export const getMagicTokenFromSearchParams = () => {
  const params = new URLSearchParams(window.location.search);
  return params.get("magicToken");
};

export const removeAnonymousTokenFromSearchParams = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const currentUrl = new URL(window.location.href);
  urlParams.delete("anonymousToken");
  currentUrl.search = urlParams.toString();

  window.history.replaceState({}, "", currentUrl.toString());
};

export const getAnonymousTokenFromSearchParams = () => {
  const params = new URLSearchParams(window.location.search);
  return params.get("anonymousToken");
};
